import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import { useAuth } from "../../context/AuthProvider"; // ✅ Import this

import "./styles/AdminMessages.css"; // ✅ Reuse same styles for now

const AdminUsers = () => {
  const { auth } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUsers = async () => {
    try {
      const response = await axios.get("/api/admin/users");
      setUsers(response.data.users);
    } catch (error) {
      console.error("🔥 Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const getCsrfToken = () => {
    return document.cookie
      .split("; ")
      .find(row => row.startsWith("csrfToken="))
      ?.split("=")[1];
  };
  
  const handleDelete = async (userId) => {
    if (!window.confirm("❗ Are you sure you want to delete this user?")) return;
    try {
      const csrfToken = getCsrfToken();
      await axios.delete(`/api/admin/users/${userId}`, {
        withCredentials: true,
        headers: { "x-csrf-token": csrfToken }
      });
      setUsers(users.filter((user) => user.id !== userId));
    } catch (error) {
      console.error("🔥 Error deleting user:", error);
    }
  };
  
  const handleRoleChange = async (userId, newRole) => {
    try {
      const csrfToken = getCsrfToken();
      await axios.put(
        `/api/admin/users/${userId}`,
        { role: newRole },
        {
          withCredentials: true,
          headers: { "x-csrf-token": csrfToken }
        }
      );
      fetchUsers(); // Refresh users after update
    } catch (error) {
      console.error("🔥 Error updating role:", error);
    }
  };
  

  return (
    <div className="admin-messages-container">
      <h2 className="messages-title">Registered Users</h2>
  
      {loading ? (
        <p className="messages-loading">Loading users...</p>
      ) : users.length === 0 ? (
        <p className="messages-empty">No users found.</p>
      ) : (
        <div className="table-wrapper">
          <table className="messages-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td>{user.id}</td>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>
                    {auth.user?.id === user.id ? (
                      user.role
                    ) : (
                      <select
                        value={user.role}
                        onChange={(e) => handleRoleChange(user.id, e.target.value)}
                        className="role-select"
                      >
                        <option value="customer">Customer</option>
                        <option value="admin">Admin</option>
                        {auth.user?.role === "siteadmin" && (
                          <option value="siteadmin">Site Admin</option>
                        )}
                      </select>
                    )}
                  </td>
                  <td>{new Date(user.created_at).toLocaleString()}</td>
                  <td className="table-actions">
                    {auth.user?.id !== user.id && (
                      <button className="btn delete-btn" onClick={() => handleDelete(user.id)}>
                        <i className="fa-solid fa-xmark"></i> Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
  
};

export default AdminUsers;
